<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/cover">THE BALLAD AND THE SOURCE</a></p>
<p class="toc1"><a href="#/Book1/Lehmann_BalladSource_3P_MD2">Part One</a></p>
<p class="toc1"><span href="#/Book1/Lehmann_BalladSource_3P_MD9" title="Link target outside of Sample">Part Two</span></p>
<p class="toc1"><span href="#/Book1/Lehmann_BalladSource_3P_MD10" title="Link target outside of Sample">Part Three</span></p>
<p class="toc1"><span href="#/Book1/Lehmann_BalladSource_3P_MD11" title="Link target outside of Sample">Part Four</span></p>
<p class="toc1"><span href="#/Book1/Lehmann_BalladSource_3P_MD12" title="Link target outside of Sample">Part Five</span></p>
<p class="toc2"><span href="#/Book2/cover" title="Link target outside of Sample">A SEA-GRAPE TREE</span></p>
<p class="toc1"><span href="#/Book2/Lehmann_SeaGrapeTree_3P_MD3" title="Link target outside of Sample">A Sea-Grape Tree</span></p>
<p class="toc1"><span href="#/Book2/Lehmann_SeaGrapeTree_3P_MD4" title="Link target outside of Sample">Postscript</span></p>
<p class="toc2"><span href="#/Comon/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?72e06f0c